// `escapeSql` shared one chart-package import line with the two chart tags in the SFC;
// it is setup logic, so setup.js imports it and only the tags are imported here.
import { BaseDonutChart } from '@rdrive/plugin-chart-donut';
import { StackedHorizontalBarChart } from '@rdrive/plugin-chart-stacked-bar';
import { ItemsGrid } from '@rdrive/plugin-items-grid';
import { TotalCard, TotalCardWithSwitch } from '@rdrive/plugin-total-cards';
import setup from './setup.js';

export default {
  name: 'controllers-page',
  components: { BaseDonutChart, StackedHorizontalBarChart, ItemsGrid, TotalCard, TotalCardWithSwitch },
  setup,
};
